<template>
  <div id="app6">
      <Carousel_new class="el" :vertical='false' :verticalS='false' :items='4' :rows='1' :controls='false' :images="images" :texts="texts" :names="names" :links="links"/>
      <Carousel_new class="en" :vertical='false' :verticalS='false' :items='4' :rows='1' :controls='false' :images="images" :texts="textsen" :names="namesen" :links="links"/>
  </div>
</template>

<script>
import Carousel_new from './components/Carousel_new';

export default {
  name: 'AppNew',
  components: {
    Carousel_new,
  },
  data: () => ({
   images:[
    '/wp-content/uploads/2023/06/diet1.jpg',
    '/wp-content/uploads/2023/06/gonimopoiisi.jpg',
    '/wp-content/uploads/2023/06/kapnisma.jpg',
    '/wp-content/uploads/2023/07/kroustika.webp',
    '',
   ],
   texts:[
      'ΝΕΦΡΟΛΙΘΙΑΣΗ',
      'ΑΚΡΑΤΕΙΑ ΟΥΡΩΝ',
      'ΣΤΥΤΙΚΗ ΔΥΣΛΕΙΤΟΥΡΓΙΑ',
      'ΚΡΟΥΣΤΙΚΑ ΚΥΜΑΤΑ',
      '',
    ],
    names:[
      'Οι επιπτώσεις τις στυτικής δυσλειτουργίας τόσο στους άνδρες όσο και στις συντρόφους τους είναι πολύ ...',
      'Σημαντικό πρόβλημα για τις γυναίκες με επιτακτική ακράτεια ούρων είναι η κακή ποιότητα ύπνου ...',
      'Οι επιπτώσεις τις στυτικής δυσλειτουργίας τόσο στους άνδρες όσο και στις συντρόφους τους είναι ...',
      'Η εφαρμογή κρουστικών κυμάτων απευθείας στο πέος αποτελεί μια επαναστατική, ανώδυνη μέθοδο ... ',
      '',
    ],
    links:[
      '/nefrolithiasi/',
      '/akratia-ouron-iatropedia/',
      '/epiptoseis-stitiki-dislitourgia/',
      '/kroustika-athens-voice',
      '',
    ],


    textsen:[
      'Taygetos Honey',
      'Geomat',
      'Geoterra',
      'Α2Ζ',
      'Tecnica',
    ],
    namesen:[
      'Honey Producer',
      'Agricultural Supplies',
      'Geomechanics Engineering',
      'Energy Solutions',
      'Electronics',
    ]
    
    })
}
</script>
